var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-20 w-full"},[_c('img',{staticClass:"my-0 mx-auto text-center",attrs:{"src":"https://a.storyblok.com/f/118728/480x491/4c73c97bde/tim-produksi.jpg/m/","alt":"tim produksi kostum badut maskot"}}),_vm._v(" "),_c('h1',{staticClass:"text-center"},[_vm._v("Oops, error")])])
}]

export { render, staticRenderFns }